export default __webpack_public_path__ + "static/media/015-hose.14642726.png";